import * as RadixPopover from "@radix-ui/react-popover";
import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/cn";
import { POPOVER_MOTION } from "@/lib/motion";

/**
 * 팝오버. 시안 02-2(내 프로필)처럼 트리거 옆에 붙어 뜨는 패널.
 * 모달과 달리 배경을 어둡게 덮지 않고, 바깥을 클릭하면 닫힌다.
 */
function PopoverContent({
  className,
  sideOffset = 8,
  align = "start",
  ...rest
}: ComponentPropsWithoutRef<typeof RadixPopover.Content>) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(
          "z-50 overflow-hidden rounded-2xl bg-surface shadow-popover focus:outline-none",
          POPOVER_MOTION,
          className,
        )}
        {...rest}
      />
    </RadixPopover.Portal>
  );
}

export const Popover = Object.assign(RadixPopover.Root, {
  Trigger: RadixPopover.Trigger,
  Content: PopoverContent,
  Close: RadixPopover.Close,
  Anchor: RadixPopover.Anchor,
});
